import { Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";

function TableInfo() {

  return (
    <>
      <Paper sx = {{width: "100%"}}>
          <Card variant={"outlined"} sx={{ width: "100%", padding: "15px" }}>
            <Typography variant="h3">{"Kharkiv Interactive Tool"}</Typography>
          </Card>
      </Paper>
    </>
  );
}

export default TableInfo;
